export default __webpack_public_path__ + "static/media/gasag_background_l1.e2ba1213.jpg";